

export function FilterStatus(data) {
  const result = data.map(item => ({
    ...item,
    status: item.status == '1' ?
      (<span className="badge bg-success">Active</span>)
      :
      (<span className="badge bg-danger">Inactive</span>)
  }));

  return result
}